import styled, { css } from 'styled-components';
import { em } from '../../styles';
import { Button } from '../../components/_shared/Button';
import { typographyStyle } from '../../components/_shared/Typography';
import { Link } from '../../components/_shared/Link';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.colors.white};
  `}
`;

export const UploadContainer = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    background: ${theme.colors.white};
    align-items: baseline;
    gap: ${em(50)};
    border: 2px ${theme.colors.nature.n3};
    justify-content: center;
  `}
`;

export const UploadFileItem = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    padding: ${em(5)} ${em(20)};
    background: ${theme.colors.white};
    align-items: baseline;
    justify-content: space-between;
    border-radius: ${em(5)};
    border: 1px solid ${theme.colors.nature.n2};
    margin-bottom: ${em(5)};
  `}
`;

export const UploadFileItemInfo = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    background: ${theme.colors.white};
    align-items: center;
    justify-content: space-between;
    gap: ${em(20)};
  `}
`;

export const MissionItem = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: wrap;
    background: ${theme.colors.white};
    align-items: center;
    justify-content: space-between;
  `}
`;

export const MissionItemBlock = styled(Wrapper)`
  ${({ theme }) => css`
    padding: ${em(10)} ${em(20)};
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.nature.n3};
    border-radius: 10px;
    box-shadow: 0 ${em(5)} ${em(5)} rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    margin-bottom: ${em(5)};
  `}
`;

export const MissionItemInfo = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    background: ${theme.colors.white};
    align-items: center;
    justify-content: space-between;
    gap: ${em(20)};
  `}
`;

export const MissionActions = styled(Wrapper)`
  ${({ theme }) => css`
    display: flex;
    background: ${theme.colors.white};
    align-items: center;
    justify-content: flex-end;
    gap: ${em(50)};
    padding-top: ${em(20)};
    padding-bottom: ${em(10)};
  `}
`;

export const FilesContainer = styled(Wrapper)`
  ${() => css`
    padding-right: ${em(20)};
  `}
`;

export const MissionListContainer = styled(Wrapper)`
  ${({ theme }) => css`
    padding: 16px;
    min-width: 50%;
    background: ${theme.colors.white};
    font-family: sans-serif;
    align-items: center;
  `}
`;

export const MissionsContainer = styled(Wrapper)`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    border-radius: 12px;
    border: 1px solid ${theme.colors.nature.n1};
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
    transition: box-shadow 0.2s ease, transform 0.2s ease;
    padding: ${em(20)} ${em(50)};
    min-height: 75dvh;
  `}
`;
export const MissionDateInfo = styled(Wrapper)`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    display: flex;
    flex-direction: column;
    font-family: sans-serif;
    padding: ${em(10)} ${em(20)};
  `}
`;
export const PaginationBlock = styled.div`
  ${({ theme }) => css`
    display: block;
    margin-top: auto;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    margin-right: ${em(12)};
    ${typographyStyle({ theme, variant: 'body2' })};
    font-size: ${em(20)};
    color: ${theme.colors.black};
    font-weight: 600;
  `}
`;

export const HelpText = styled.p`
  ${({ theme, fontSize }) => css`
    margin-right: ${em(12)};
    ${typographyStyle({ theme, variant: 'body2' })};
    font-size: ${fontSize ? em(fontSize) : em(14)};
    display: inline-block;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
  `}
`;
export const FailReasonText = styled.p`
  ${({ theme, fontSize }) => css`
    margin-right: ${em(12)};
    max-width: 500px;
    ${typographyStyle({ theme, variant: 'body2' })};
    font-size: ${fontSize ? em(fontSize) : em(14)};
    display: inline-block;
    color: ${theme.colors.failed};
  `}
`;

export const MissionListTitleContainer = styled(Wrapper)`
  ${({ theme }) => css`
    background: ${theme.colors.white};
    display: flex;
    justify-content: space-between;
    font-family: sans-serif;
  `}
`;

export const DownloadButton = styled.a`
  color: #545454;
  text-decoration: none;
`;

export const SortButton = styled(Button)`
  ${({ theme }) => css`
    padding: ${em(6)} ${em(12)};
    ${typographyStyle({ theme, variant: 'body2' })};
    display: flex;
    background: ${theme.colors.white};
    color: ${theme.colors.black};
    font-size: 14px;
    &:hover {
      font-weight: bold;
      background: ${theme.colors.white};
      color: ${theme.colors.black};
    }
  `}
`;
